import bem from 'utils/bem';

export const block = bem('waveform-preset-list');
